import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/marekbaranowski/Desktop/dev/rxp-all/reactivepad/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/marekbaranowski/Desktop/dev/rxp-all/reactivepad/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/42c74ee7ef137e0776fe539dbbb2c380.js')["default"];

var scope_2 = require('/Users/marekbaranowski/Desktop/dev/rxp-all/reactivepad/packages/docs/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/80e2c6472ab6bc6ab79043a8bc27ff7d.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2);